import * as $ from "jquery";
import * as _ from "lodash";
import { Utils } from "../../../../../common/utils";
import { DashboardChannel } from "../../../../../models/DashboardChannel";
import { CHART_AGGREGATION_PERIOD, CHART_DATA_RANGE } from "../../../../dashboard/widgets/chart/ChartHelper";
import { ChannelsSelectionManager } from "../../../ChannelsSelectionManager";
import { BaseModifyDashboardWidgetViewOptions } from "../_BaseModifyWidgetView";

export class ModifyMultiGaugeWidget extends ChannelsSelectionManager {

    private widgetChannels: DashboardChannel[];
    private template = _.template(require('templates/modals/dashboard/modify_widgets/multigauge/multigauge.html'));
    channelsTemplate = _.template(require('templates/modals/dashboard/modify_widgets/multigauge/multigaugechannels.html'));

    constructor(options: BaseModifyDashboardWidgetViewOptions) {
        super(<any>_.extend({
            tagName: "div",
            className: 'widget-type-multigauge',
            events: {
                'click .add-channel-btn': 'handleAddChannelBtnClick',

                // Ranges
                'change .advanced-config-checkbox': 'handleConfigToggleChange',
                'click .add-threshold-btn': 'handleAddThreshold',
                'click .delete-threshold-btn, .delete-threshold-btn-mobile': 'handleDeleteThreshold',
                'input .threshold-name, .threshold-value': 'handleThresholdInput',
                'click .use-defaults-btn': 'handleUseDefaultsBtn',
                
                'change .custom-labels-config-checkbox': 'handleCustomLabelsToggleChange',
                
                // Chart Channel Changes
                'change .widget-channel-select-install': 'handleInstallSelectChange',
                'change .widget-channel-select-module': 'handleModuleSelectChange',
                'change .widget-channel-select-channel': 'handleChannelSelectChange',
                'click .widget-channel-delete': 'handleChannelDelete',
                'click .thresholds-minimized': 'handleThresholdClick',
                'input .thresholds input': 'handleThresholdsInput',
                'input .limits input': 'handleLimitsInput',
                'click .limits-minimized': 'handleLimitsClick',
                'click .fa.fa-chevron-up.move-up': 'handleMoveChannelUp',
                'click .fa.fa-chevron-down.move-down': 'handleMoveChannelDown',
                'change .aggregation-period select': 'handleAggregationPeriodChange',
                'change .tab select': 'handleTabChange',
            }
        }, options));

        this.widgetChannels = null;
        if (!this.options.widget) {
            this.options.widget = new this.options.dashboardWidgetCollection.model({
                dashboard_id: this.options.dashboardId,
                params: []
            });
            this.widgetChannels = [];
        } else {
            this.widgetChannels = this.options.dashboardChannelCollection.where({
                dashboard_widget_id: this.options.widget.get('id')
            });
        }
    }

    render() {
        const rawAdvancedConfig = this.options.widget.getParamValue('ADVANCED_CONFIG', false);
        // coerce the raw value -- which may be a boolean, number, or string -- into a boolean
        this.advancedConfig = !!Number(rawAdvancedConfig);

        const rawUseCustomLabelsConfig = this.options.widget.getParamValue('USE_CUSTOM_LABELS', true);
        // coerce the raw value -- which may be a boolean, number, or string -- into a boolean
        this.useCustomLabels = !!Number(rawUseCustomLabelsConfig);

        this.$el.html(this.template({
            dashboardCategoryCollection: this.options.dashboardCategoryCollection,
            dashboardTabCollection: this.options.dashboardTabCollection,
            widget: this.options.widget,
            report: this.options.report,
            advancedConfig: this.advancedConfig,
            useCustomLabels: this.useCustomLabels,
            img_url: require('../../../../../../img/widgettypes/multigauge/multigauge.png'),
            categoryId: this.options.widget.get('dashboard_category_id') ?
                this.options.widget.get('dashboard_category_id') : this.options.categoryId,
            tabId: this.options.tabId
        }));
        this.$('select').select2(Utils.Select2.defaultOptions);
        //Initialize bootstrap toggle for advanced configuration
        (<any>this.$el.find('input[type="checkbox"]')).bootstrapToggle();

        if (!this.options.widget.isNew()) {
            super.buildInitialChannels();
            super.switchAggPeriod();
        } else {
            super.renderNewChannelRow();
        }

        return this;
    }

    show() {
        this.$('.tab select').select2(Utils.Select2.defaultOptions);
        this.initializeCategorySelect('.category select');
    }

    handleTabChange(e: JQuery.Event) {
        var $select = this.$('.tab select');
        var rawValue = $select.val();
        var tabId = rawValue === '' || rawValue === null || rawValue === undefined ? null : Number(rawValue);
        this.options.tabId = tabId;
        this.reloadCategoriesForTab(tabId);
    }

    preSave() {
        var aggregationTypesArr = [];
        if (this.$('.aggregation-period select').val() != '0') {
            aggregationTypesArr = _.map(this.$('.widget-channel-select-aggregation-type'), (type) => {
                return $(type).val();
            });
        }

        this.options.widget.setParamValue('LOCATION', this.$('.location-input').val());
        this.options.widget.setParamValue('CHART_AGGREGATION_TYPE', aggregationTypesArr.join(','));
        this.options.widget.setParamValue('CHART_AGGREGATION_PERIOD', this.$('.aggregation-period select').val());
        this.options.widget.setParamValue('CHART_DATA_RANGE', this.getDataRangeEquivalent(this.$('.aggregation-period select').val()));

        this.options.widget.setParamValue('ADVANCED_CONFIG', this.advancedConfig);
        this.options.widget.setParamValue('USE_CUSTOM_LABELS', this.useCustomLabels);

        return true
    }

    private getDataRangeEquivalent(aggregationPeriod: CHART_AGGREGATION_PERIOD) {
        // This is not the same as ChartHelper.getDataRangeEquivalent because we need to request more data
        // in order to support dynamic limits
        switch (aggregationPeriod) {
            case CHART_AGGREGATION_PERIOD.DAY:
            case CHART_AGGREGATION_PERIOD.HOUR:
            case CHART_AGGREGATION_PERIOD.MINUTE_15:
            case CHART_AGGREGATION_PERIOD.MINUTE_30:
                return CHART_DATA_RANGE.WEEK_1;
            case CHART_AGGREGATION_PERIOD.WEEK:
                return CHART_DATA_RANGE.MONTH_1;
            case CHART_AGGREGATION_PERIOD.MONTH_1:
                return CHART_DATA_RANGE.MONTH_3;
            case CHART_AGGREGATION_PERIOD.MONTH_3:
                return CHART_DATA_RANGE.MONTH_6;
            case CHART_AGGREGATION_PERIOD.MONTH_6:
                return CHART_DATA_RANGE.YEAR_1;
            case CHART_AGGREGATION_PERIOD.YEAR:
                return CHART_DATA_RANGE.YEAR_1;
            default:
                return CHART_DATA_RANGE.WEEK_1;
        }
    }

    postSave() {
        var widgetChannels = this.options.dashboardChannelCollection.where({
            dashboard_widget_id: this.options.widget.get('id')
        });

        var channelsRow = this.$('.channel-selects');
        var limits = {};
        _.each(channelsRow, (row, i) => {
            var $row = $(row);

            var channel = _.find(widgetChannels, (c) => { return c.get('dashboard_channel_order') === i; });
            // When moving widget to a different tab, collection may not have channels for the (new) widget yet; use row's dashboard_channel_id as fallback
            var channelId = channel ? channel.get('dashboard_channel_id') : Number($row.find('.widget-dashboard-channel-id').val());
            if (channelId == null || isNaN(channelId)) return;

            var minimum = $row.find('.channel-limits .limits .minimum-limit').val();
            var maximum = $row.find('.channel-limits .limits .maximum-limit').val();
            var nominalValue = $row.find('.channel-limits .limits .nominal-value').val();

            limits[channelId] = {
                lower_limit: (minimum == '') ? null : Number(minimum),
                upper_limit: (maximum == '') ? null : Number(maximum),
                nominal_value: (nominalValue == '') ? null : Number(nominalValue)
            };
        });
        this.options.widget.setParamValue('MULTIGAUGE_LIMITS', JSON.stringify(limits));

        // the API for postSave is synchronous, but this implementation requires handling of an async XHR operation -- problem!
        this.options.widget.save(); // TODO: fix to not drop the outcome of the XHR
        return true;
    }

    onUpdateChannelRows() {
        var rows = this.$('.channel-selects');
        (rows.length >= 14) ? $('.add-channel-btn').hide() : $('.add-channel-btn').show();
    }

    onBuildInitialChannels(c, row) {
        var limits = (this.options.widget.getParamValue('MULTIGAUGE_LIMITS', null)) ? JSON.parse(this.options.widget.getParamValue('MULTIGAUGE_LIMITS', {})) : {};

        if (!limits[c.get('dashboard_channel_id')]) {
            var order = 0;
            _.each(limits, (limit) => {
                if (order == c.get('dashboard_channel_order')) {
                    limits[c.get('dashboard_channel_id')] = limit;
                }
                order++;
            })
        }

        var lower = limits[c.get('dashboard_channel_id')].lower_limit;
        var upper = limits[c.get('dashboard_channel_id')].upper_limit;
        var nominalValue = limits[c.get('dashboard_channel_id')].nominal_value;

        row.find('.channel-limits .limits .minimum-limit').val(lower);
        row.find('.channel-limits .limits .maximum-limit').val(upper);
        row.find('.channel-limits .limits .nominal-value').val(nominalValue)

        lower = lower == null ? 'Auto' : lower;
        upper = upper == null ? 'Auto' : upper;
        nominalValue = nominalValue == null ? 'N/A' : nominalValue;
        row.find('.channel-limits .limits-badges .min-limit').html(lower);
        row.find('.channel-limits .limits-badges .max-limit').html(upper);
        row.find('.channel-limits .limits-badges .nom-value').html(nominalValue)
    }

    getChannelDifference() {
        var channelsSeen = [];
        var create = [];
        var update = {};
        var rows = this.$('.channel-selects');
        _.each(rows, (row, i) => {
            var $row = $(row);
            var channelId = $row.find('.widget-channel-select-channel').val();

            var dashboardChannelIdField = $row.find('.widget-dashboard-channel-id');
            var dashboardChannelId = Number(dashboardChannelIdField.val());

            //If the row has no channelId, make sure not to delete it if its a result of not having permissions to view an install
            if (!channelId) {
                channelId = $row.find('.widget-channel-select-channel').data('channelId');
                if (channelId) channelsSeen.push(dashboardChannelId);
                return;
            }
            channelId = Number(channelId);

            var rangesList = this.advancedConfig ? this.getRangesListFromAdvancedThresholds(row) : this.getRangesListFromRegularThresholds(row);

            // Use default name or custom name based on configuration
            const installSelect = $row.find('.widget-channel-select-install');
            const installId = (<string>$(installSelect).val());
            const moduleNumber = $row.find('.widget-channel-select-module').val();
            const moduleCollection = this.options.moduleCollections && this.options.moduleCollections[installId];
            const module = moduleCollection ? moduleCollection.findWhere({ module_number: moduleNumber }) : undefined;
            const channel = module ? module.getChannelById(channelId) : undefined;
            // When moving widget to different tab, module/channel lookup can be missing; skip this row for create/update but preserve channelsSeen so we don't delete
            if (!module || !channel) {
                if (dashboardChannelId) channelsSeen.push(dashboardChannelId);
                return;
            }
            let name = (<string>$row.find('.widget-channel-label').val()).trim();
            if (!this.useCustomLabels) name = `${module.get('module_location')} - ${channel['channel_name']}`;

            var upsert = {
                dashboardId: this.options.dashboardId,
                widgetId: this.options.widget.get('id'),
                channelId: channelId,
                order: i,
                name: name,
                critLow: null,
                warnLow: null,
                warnHigh: null,
                critHigh: null,
                rangesList: rangesList
            };
            if (dashboardChannelId) {
                channelsSeen.push(dashboardChannelId);

                // Make sure we had permission to update this channel
                if (!dashboardChannelIdField.attr('data-ignore-update')) update[dashboardChannelId] = upsert;
            } else {
                create.push(upsert)
            }
        });

        var _delete = [];
        _.each(this.widgetChannels, (c) => {
            var dcid = c.get('dashboard_channel_id');
            if (!_.includes(channelsSeen, dcid)) _delete.push(dcid);
        });

        return [create, update, _delete]
    }

    handleLimitsClick(e: JQuery.UIEventBase) {
        var limitsContainer = $(e.currentTarget).parents('.channel-limits').find('.limits');
        var hidden = limitsContainer.hasClass('hidden');
        if (hidden) {
            limitsContainer.removeClass('hidden');
        } else {
            limitsContainer.addClass('hidden');
        }
    }

    handleLimitsInput(e: JQuery.UIEventBase) {
        var targetInput: any = $(e.currentTarget);
        var val = (<string>targetInput.val());
        if (val == '') {
            ($(targetInput).hasClass('nominal-value')) ? val = 'N/A' : val = 'Auto';
        } else {
            if (_.isNaN(Number(val))) {
                ($(targetInput).hasClass('nominal-value')) ? val = 'N/A' : val = 'Auto';
            }
        }

        var allInputs = targetInput.parents('.limits').find('input');
        for (var i = 0; i < allInputs.length; i++) {
            if (allInputs.eq(i).is(targetInput)) break;
        }

        var badge = targetInput.parents('.channel-limits').find('.limits-badges .badge:eq(' + i + ')');
        badge.text(val);
    }

}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/dashboard/modify_widgets/multigauge/ModifyMultiGaugeWidget.ts